var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ImageThumbArea from './image_thumb_area';
import SummaryInfoBasic from './basic';
import SummaryInfoDetail from './detail';
var SummaryInfo = function () {
    var item = useSelector(function (state) { return state.product.item; });
    var match = useRouteMatch();
    // const isMinishop = Boolean(match.params.idx_b_manager)
    // const itemLoadState = useSelector((state:RootState)=> state.product.itemLoaded)
    // const dispatch = useDispatch()
    // const priceObj = {
    //     price: (isMinishop ? item?.minishop?.price_b2c || 0 : item?.price_low || 0),
    //     f_sellout: item?.f_sellout || 0,
    //     cnt_strock: item?.minishop?.cnt_stock || 0,
    //     seller: item?.seller || 0,
    //     isMinishop,
    // }
    // const priceData = priceState(priceObj)
    // useEffect(() => {
    //     fetchPriceData()
    // }, [priceData])
    // const fetchPriceData =()=>{
    //     dispatch(
    //         {
    //             type: SET_PRICE_DATA,
    //             payload: priceData
    //         }
    //     )
    // }
    if (!item)
        return null; //로딩바 구현으로 주석
    return (React.createElement(Style, null,
        item &&
            React.createElement(ImageThumbArea, { thumbData: item.thumbnail, imgCount: item.cnt_img, maker_name: item.maker_name, date_launch: item.date_launch, date_reg: item.date_reg }),
        // 2022-04-08 대표님 지시로 변경
        // 내용 : 현재 가격비교 화면이 아닌 동일한 화면 노출하고 아래 사양 적용되어야 합니다.
        //
        // - 상단 : 금액, 무료배송, 바로구매하기 --> 일시품절
        // - 사양변경 --> Select Box Disable
        // - 하단 : 개수 hidden, 금액, 바로구매하기 --> 일시품절
        // 조립PC 가 아닌 단품에도 품절일 때 가격비교가 적용되어 있네요.
        // priceData === 3 ?
        //     (
        //         <div>{match.params.idx_b_manager ?
        //                 <SummaryInfoDetail/> :
        //                 <SummaryInfoBasic/>
        //             }
        //         </div>
        //     )
        //     : (<Price {...priceObj} />)
        React.createElement("div", null, match.params.idx_b_manager ?
            React.createElement(SummaryInfoDetail, null) :
            React.createElement(SummaryInfoBasic, null))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    margin: 0 0 100px;\n\n    .no_price {\n        align-self: flex-start;\n        margin: 0 0 0 20px;\n        padding: 20px 0;\n        width: 100%;\n        font-size: 30px;\n        color: #ec0000;\n        font-weight: 700;\n        border-bottom: 1px solid #ddd;\n    }\n"], ["\n    display: flex;\n    margin: 0 0 100px;\n\n    .no_price {\n        align-self: flex-start;\n        margin: 0 0 0 20px;\n        padding: 20px 0;\n        width: 100%;\n        font-size: 30px;\n        color: #ec0000;\n        font-weight: 700;\n        border-bottom: 1px solid #ddd;\n    }\n"])));
export default SummaryInfo;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/summary_info/index.tsx
// module id = 199
// module chunks = 0